import { getConsoleStyle as o } from "./styledLogs.js";
const s = (e) => console.log("%c%s", o(), e), n = () => {
  s(`You are a Developer? RIO is hiring!
https://company.rio.cloud/en/career/jobs`);
};
export {
  n as weAreHiring
};
//# sourceMappingURL=weAreHiring.js.map
